import axios from 'axios';

const deleteTourItem = async (tourId: string, tourItemId: string) => {
  await axios.delete(`/tours/${tourId}/delete_tour_item/${tourItemId}`);
};

export default deleteTourItem;
